<app-menu headerCSS="header-transparent"></app-menu>
<div class="header">
   <!-- <candidate-filter></candidate-filter>  -->
</div>

<div class="header-inner bg-light">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="jobber-user-info">
            <div class="profile-avatar">
              <img class="img-fluid " [src]="photoPath" alt="">
            </div>
            <div class="profile-avatar-info ml-4">
               <h3>{{companyName}}</h3>
            </div>
          </div>
      </div>
    </div>
  </div>
</div>
<app-dashboard-employer-menu></app-dashboard-employer-menu>
<router-outlet></router-outlet>
<app-footer></app-footer>